/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import { useI18n } from '../providers/I18nProvider';
export const useStaticIntl = (factory, ...factoryArgs) => {
    const intl = useI18n();
    return useMemo(() => factory(intl, ...factoryArgs), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [factory, intl, ...factoryArgs]);
};
//# sourceMappingURL=useStaticIntl.js.map